import { combineReducers } from 'redux-immutable';

import layout from './layout.duck';

export default combineReducers({
  layout
});
